namespace appn.views.messageText.edit {
    class InitArgs {
        defaultInvite: string = appn.emptyString;
        defaultForgotPassword: string = appn.emptyString;
        defaultFile: string = appn.emptyString;
        defaultNoticeAlert: string = appn.emptyString;
    }

    let _initArgs: InitArgs;
    export let inviteEditor: any = {};
    export let forgotPasswordEditor: any = {};
    export let fileEditor: any = {};
    export let noticeAlertEditor: any = {};

    export function init(args: InitArgs): void {
        _initArgs = args;

        // Code Mirror Editors
        inviteEditor = appn.codeMirror.applyToTextArea('#MessageText_UserInviteHtml', appn.codeMirror.codeTypes.htmlAndScript);
        forgotPasswordEditor = appn.codeMirror.applyToTextArea('#MessageText_UserForgotPasswordHtml', appn.codeMirror.codeTypes.htmlAndScript);
        fileEditor = appn.codeMirror.applyToTextArea('#MessageText_FileEmailHtml', appn.codeMirror.codeTypes.htmlAndScript);
        noticeAlertEditor = appn.codeMirror.applyToTextArea('#MessageText_NoticesAlertHtml', appn.codeMirror.codeTypes.htmlAndScript);

        addEvents();
    }

    function addEvents(): void {
        $('.restore-default-invite').on('click', function() {
            inviteEditor?.setValue(_initArgs.defaultInvite);
            appn.toast.notify(toast.Type.info, 'Default user invite body HTML has been restored, don\'t forget to hit save.');
        });

        $('.restore-default-forgot-password').on('click', function() {
            forgotPasswordEditor?.setValue(_initArgs.defaultForgotPassword);
            appn.toast.notify(toast.Type.info, 'Default user forgot password body HTML has been restored, don\'t forget to hit save.');
        });

        $('.restore-default-file').on('click', function() {
            fileEditor?.setValue(_initArgs.defaultFile);
            appn.toast.notify(toast.Type.info, 'Default file email HTML has been restored, don\'t forget to hit save.');
        });

        $('.restore-default-noticeAlert').on('click', function() {
            noticeAlertEditor?.setValue(_initArgs.defaultNoticeAlert);
            appn.toast.notify(toast.Type.info, 'Default notice alert HTML has been restored, don\'t forget to hit save.');
        });
    }
}
